import React, { useState, useEffect } from 'react';
import { Checkbox, Empty, Typography } from 'antd';
import RangeSlider from '../components/RangeSlider';
import Parameter from './components/Parameter';

import ParametersTabs from '../components/ParametersTabs';
import styles from './index.scss';
import RiskIndicators from '../components/RiskIndicators';
import { ALERT_SOURCE_MAPPING } from '../../../../../util/GlobalConstant';
import { connect } from 'react-redux';
import { round } from '../../../../../util/lodashlike';

const weightageCategoryRangeError = `Sum of all the categories should be 100%`;

function MatchingConfigParams({
  configNameValues,
  data = [],
  handleChange,
  handleChangeWeightage,
  handleChangeHardRule,
  weightage,
  hardRule,
  activeKey = '0',
  setActiveKey,
  readOnly = false,
  saveMatchingConfigToStore,
  weightageErrorFromStore,
  disabled,
  recommandedChecksFlags,
  setRecommandedChecksFlags,
  setActiveTab,
  activeTab,
  riskIndicatorsState,
  isLoadingRI,
  setRiskIndicatorData,
  riskIndicatorsData,
  handRiskIndicatorsWeightAge,
  fetchRiskIndicators,
  isDeployProduction,
  currentModule,
  deployedRiskIndicators,
  resetCountRI
}) {
  const [weightageError, setWeightageError] = useState({
    Name: weightageErrorFromStore?.Name || '',
    Address: weightageErrorFromStore?.Address || '',
    Date: weightageErrorFromStore?.Date || ''
  });

  useEffect(() => {
    if (!isDeployProduction) {
      const w = Object.keys(weightage).reduce(
        (acc, key) =>
          weightage?.[key] > 100 || weightage?.[key] < 0
            ? { ...acc, [key]: weightageCategoryRangeError }
            : { ...acc, [key]: '' },
        {}
      );
      setWeightageError(w);
      if (Object.keys(w).find((e) => w[e]))
        handleChangeWeightage('Name', weightage['Name'], '');
    }
  }, []);

  const handleRangeChange = (value, unique_id) => {
    const key = data[activeKey]?.categoryType;
    setRecommandedChecksFlags({
      ...recommandedChecksFlags,
      [activeTab?.categoryType]: false
    });

    handleChange(
      data.map((d) =>
        d.categoryType === key
          ? {
              ...d,
              parameterList: d.parameterList.map((p) =>
                p.score.unique_id === unique_id
                  ? { ...p, score: { ...p.score, value } }
                  : p
              )
            }
          : d
      )
    );
  };

  const setRecommendedValue = () => {
    const key = data[activeKey]?.categoryType;
    handleChange(
      data.map((d) =>
        d.categoryType === key
          ? {
              ...d,
              parameterList: d.parameterList.map((p) => {
                return {
                  ...p,
                  score: {
                    ...p.score,
                    value: parseFloat(p.recommendedScore).toFixed(2)
                  }
                };
              })
            }
          : d
      )
    );
  };

  const _handleChangeWeightage = (name, value) => {
    const minVal = 0;
    const maxVal = 100;
    let errorMsg = '',
      maxValue = 0,
      isAnyEmpty = false,
      emptyTab = '';

    for (const tab of Object.keys(weightage)) {
      let currentTabValue = weightage[tab] ? weightage[tab] : 0;

      if (tab !== name) {
        maxValue = round(maxValue, 2) + round(currentTabValue, 2);

        if (weightage[tab] === undefined || weightage[tab] < 0) {
          isAnyEmpty = true;
          emptyTab = tab;
        }
      }
    }
    maxValue = round(maxValue, 2) + round(value, 2);

    if (!value) {
      errorMsg = `Weightage should not be empty for ${name}`;
    } else if (
      +value < minVal ||
      +value > maxVal ||
      Number.isNaN(value) ||
      Number.isNaN(maxValue)
    ) {
      errorMsg = weightageCategoryRangeError;
    } else if (maxValue > maxVal) {
      errorMsg = weightageCategoryRangeError;
    } else if (maxValue < maxVal) {
      errorMsg = weightageCategoryRangeError;
    } else if (isAnyEmpty) {
      errorMsg = `Weightage should not be empty for ${emptyTab}`;
    } else if (maxValue == maxVal) {
      errorMsg = '';
    } else {
      return;
    }

    let error = {};
    if (errorMsg) {
      const weightageErrors = { ...weightageError, ...weightageErrorFromStore };
      error = {
        ...weightageErrors,
        Name: errorMsg,
        Address: errorMsg,
        Date: errorMsg
      };
      setWeightageError(error);
      if (saveMatchingConfigToStore && Object.values(error)) {
        saveMatchingConfigToStore('weightageError', error, true);
      }
    } else {
      if (saveMatchingConfigToStore) {
        saveMatchingConfigToStore('weightageError', error, true);
      }
    }

    handleChangeWeightage(name, value, errorMsg ? false : true);
  };

  let tabs = [];
  tabs = data.reduce((newArr, item, index) => {
    let tabParameterCount =
      data?.find((d) => d.categoryType === item.categoryType)?.parameterList
        ?.length || 0;

    newArr.push({
      name: `${item.categoryType}${
        tabParameterCount === 0 ? '' : `(${tabParameterCount})`
      }`,
      key: index,
      component: () => (
        <Parameter
          activeTab={item}
          readOnly={readOnly || disabled}
          columns={columns()}
          dataSource={
            data?.find((d) => d.categoryType === item.categoryType)
              ?.parameterList || []
          }
          handleChangeWeightage={(value) =>
            _handleChangeWeightage(item.categoryType, value)
          }
          handleChangeHardRule={handleChangeHardRule}
          hardRule={hardRule}
          weightage={weightage[item.categoryType]}
          weightageError={weightageErrorFromStore?.Name}
        />
      )
    });

    return newArr;
  }, []);

  const columns = () => [
    {
      title: 'Parameter Name',
      key: 'displayName',
      dataIndex: 'displayName',
      width: '40%',
      ellipsis: true,
      render: (name) => <div className={styles.tableText}>{name || '-'}</div>
    },
    {
      title: 'Score',
      key: 'score',
      dataIndex: 'score',
      width: '40%',
      ellipsis: true,
      render: (score, record) => (
        <div>
          <RangeSlider
            value={score?.value}
            marks={score?.recomended}
            description={score?.description}
            behaviour={score?.behaviour}
            min={record?.minValue}
            max={record?.maxValue}
            step={record?.increment}
            readOnly={readOnly || disabled}
            unique_id={score?.unique_id}
            handler={handleRangeChange}
          />
        </div>
      )
    },
    {
      title: () => (
        <div>
          Recommended Score Value{' '}
          {!disabled && (
            <Checkbox
              checked={recommandedChecksFlags?.[activeTab?.categoryType]}
              onChange={() => {
                setRecommendedValue();
                setRecommandedChecksFlags({
                  ...recommandedChecksFlags,
                  [activeTab?.categoryType]:
                    !recommandedChecksFlags?.[activeTab?.categoryType] || false
                });
              }}
            />
          )}
        </div>
      ),
      key: 'recommendedScore',
      dataIndex: 'recommendedScore',
      width: '20%',
      ellipsis: true,
      render: (recommendedScore) => parseFloat(recommendedScore).toFixed(2)
    }
  ];
  const changeTabHandler = (i) => {
    setActiveKey(i);
    setActiveTab(data[i]);
  };

  useEffect(() => {
    if (configNameValues?.sourceIds === ALERT_SOURCE_MAPPING.RS) {
      fetchRiskIndicators();
    }
  }, [configNameValues]);

  if (
    configNameValues?.sourceIds === ALERT_SOURCE_MAPPING.RS ||
    currentModule === parseInt(ALERT_SOURCE_MAPPING.RS)
  ) {
    return (
      <RiskIndicators
        isLoading={isLoadingRI}
        riskIndicatorsState={riskIndicatorsState}
        setRiskIndicatorData={setRiskIndicatorData}
        riskIndicatorsData={riskIndicatorsData}
        handRiskIndicatorsWeightAge={handRiskIndicatorsWeightAge}
        disabled={disabled}
        isDeployProduction={isDeployProduction}
        deployedRiskIndicators={deployedRiskIndicators}
        resetCount={resetCountRI}
      />
    );
  } else {
    if (data?.length === 0) {
      return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
    } else
      return (
        <div className={styles.__matchingConfigParam__} id="range_slider">
          <ParametersTabs
            tabs={tabs}
            activeKey={activeKey}
            activeTab={activeTab}
            setActiveKey={changeTabHandler}
            data={data}
            weightage={weightage}
          />
        </div>
      );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoadingRI:
      state.nsMatchingConfig.matchingConfigurationRiskParameters.isLoading ||
      state.nsRiskIndicators.riskIndicators.isLoading
  };
};

export default connect(mapStateToProps)(MatchingConfigParams);
